import { Mail, Globe, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { CONTACT_EMAIL } from "@/lib/constants";

export default function Contatti() {
  const copy = async () => {
    await navigator.clipboard.writeText(CONTACT_EMAIL);
    toast.success("Indirizzo copiato");
  };
  return (
    <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:py-16" data-testid="contatti-page">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0F2D5E]">Contatti</p>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">Scrivici</h1>
      <p className="mt-4 text-[#495850]">Per domande, aziende interessate o assistenza sulle tue segnalazioni, rispondiamo via email.</p>
      <section className="rise mt-10 rounded-3xl border border-[#E2E5DC] bg-white p-6 sm:p-8">
        <div className="flex items-start gap-4">
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-[#0F2D5E] text-[#F4C20D]"><Mail className="h-5 w-5" /></span>
          <div className="min-w-0">
            <p className="text-sm text-[#75867E]">Email</p>
            <a href={`mailto:${CONTACT_EMAIL}`} className="break-all text-xl font-bold text-[#0F2D5E] hover:underline sm:text-2xl" data-testid="contact-email-link">{CONTACT_EMAIL}</a>
          </div>
        </div>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Button asChild className="h-12 rounded-full bg-[#F4C20D] px-6 text-[#0F2D5E] hover:bg-[#E0B000]" data-testid="contact-write-btn">
            <a href={`mailto:${CONTACT_EMAIL}`}><Mail className="mr-2 h-4 w-4" /> Scrivi una email</a>
          </Button>
          <Button variant="outline" onClick={copy} className="h-12 rounded-full border-[#0F2D5E] text-[#0F2D5E]" data-testid="contact-copy-btn">
            <Copy className="mr-2 h-4 w-4" /> Copia indirizzo
          </Button>
        </div>
        <p className="mt-6 flex items-center gap-2 text-sm text-[#75867E]"><Globe className="h-4 w-4" /> iosegnalo.net</p>
      </section>
    </main>
  );
}
